import { color } from 'highcharts';
import { StyleSheet } from 'react-native';

export const SparkLineStyling = color => {
  return StyleSheet.create({
    container: {
      borderWidth: 4,
      borderColor: '#EBEEF2'
    },
    innerContainer: {
      borderWidth: 1,
      borderColor: '#DDE1E5'
    },
    chartContainer: {
      padding: 12,
      borderBottomWidth: 1,
      borderColor: '#DDE1E5'
    },
    dataContainer: {
      padding: 12
    },
    dataFlexContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      gap: 5
    },
    dataMicroText: {
      marginBottom: 4
    },
    btnContainer: {
      transition: 'background-color 0.2s ease',
      color: '#2c73c8',
      borderWidth: 1,
      borderColor: '#ced4db',
      borderRadius: 9999,
      paddingVertical: 4,
      paddingHorizontal: 8,
      pointerEvent: 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    btnContainerHovered: {
      backgroundColor: '#eaf3ff'
    },

    compactContainer: {
      borderWidth: 1,
      borderRadius: 20,
      padding: 16,
      borderColor: color,
      shadowColor: '#000',
      shadowOpacity: 0.05,
      shadowRadius: 8,
      shadowOffset: { width: 0, height: 3 },
      marginBottom: 16
    },

    title: {
      marginBottom: 12
    },

    mainRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    },

    leftColumn: {
      flexDirection: 'column',
      justifyContent: 'flex-start'
    },

    subRow: {
      display: 'flex',
      flexDirection: 'row',
    },

    primaryValue: {
      marginBottom: 4
    },

    primaryLabel: {
      marginBottom: 10,
    },
    maxWidthLabel: {
      maxWidth: 60,
      marginRight:3
    },

    secondaryValue: {
      marginTop: 4
    },

    secondaryLabel: {
      marginTop: -2,
      maxWidth: 60
    },

    rightColumnChart: {
      width: 90,
      height: 55,
      justifyContent: 'center',
      alignItems: 'center'
    },

    ctaButton: {
      marginTop: 14,
      borderRadius: 999,
      backgroundColor: '#FFFFFF',
      borderWidth: 1,
      borderColor: '#D3D9FF',
      alignSelf: 'center'
    },

    ctaButtonText: {
      color: '#2c73c8',
      fontWeight: '600'
    }
  });
};
export const LineCompStyling = theme => {
  return StyleSheet.create({
    sparkLineContainer: {
      flexDirection: 'row',
      overflow: 'auto',
      gap: 10
    },
    container: {
      borderWidth: 4,
      borderColor: '#DDE1E5'
    },
    loadingOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.6)',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999
    }
  });
};

export const tooltipStyling = {
  display: 'flex',
  marginBottom: '10px',
  gap: '20px',
  justifyContent: 'space-between'
};
